// removed by extract-text-webpack-plugin
module.exports = {"grid-layout":"_1WTC2Pte-rPhSNgDnudcE","view-only":"_3rvKxwYbBAZudhNfVNWnnc","grid-item":"_2s7Im3yQZOTwbpMP00UTBE","header":"_3YyCVR_JT-Po7IVUaey_Oa","heading":"_1fOI_n6Ld7CjFX1GZQ6N60","content":"_3JQZef-R86oMqssEktewD","resize-handle":"_3Wgry683WgCBXXnrIZ9cHg","dragging":"_2HERie9IyNE1in4SbQFZ_r","resizing":"hA7de7gsjprixaZntKyF3","ghost-item":"_3TKFoh-N4lh8iNPsNJg_wn","spin":"_2XzbpPz6PPZsvNGthV4V4z"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/GridLayout/styles.scss
// module id = 409
// module chunks = 18